import {IHttpService} from "angular";
import {AdviserEquityPositionRecords} from "../models/AdviserEquityPositionRecord";

export class AdviserPositionsService {
    public static readonly id = "adviserPositionsService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {
    }

    public async equityPositions(): Promise<AdviserEquityPositionRecords> {
        const url = `/tradefloor/api/equity-positions`;
        const response = await this.$http.get<AdviserEquityPositionRecords>(url);
        return response.data;
    }
}
